export const EVENT_PAYMENT_UNLOCK_PRO = 'unlock_pro';
export const EVENT_PAYMENT_UNLOCK_STARTER = 'unlock_starter';
export const EVENT_PAYMENT_UNLOCK_ULTIMATE = 'unlock_ultimate';
export const EVENT_PAYMENT_CREDITS_NEEDED = 'credits_needed';
export const EVENT_MAX_CONCURRENT_CONVERSION = 'max_concurrent_conversion';
export const EVENT_PAYMENT_GENERIC = 'payment_generic';